

/// <reference path="StockNote.ts" />

// Generated class CustomInputNote_ManagedObject

class CustomInputNote_ManagedObject extends StockNote
{
}
